import { render, staticRenderFns } from "./SupportRequestDetails.vue?vue&type=template&id=0a85246a"
import script from "../controllers/SupportRequestDetails.ts?vue&type=script&lang=ts&external"
export * from "../controllers/SupportRequestDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./SupportRequestDetails.vue?vue&type=style&index=0&id=0a85246a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports